import { render, staticRenderFns } from "./ClassroomFormModal.vue?vue&type=template&id=9e6745a6&scoped=true"
import script from "./ClassroomFormModal.vue?vue&type=script&lang=js"
export * from "./ClassroomFormModal.vue?vue&type=script&lang=js"
import style0 from "./ClassroomFormModal.vue?vue&type=style&index=0&id=9e6745a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e6745a6",
  null
  
)

export default component.exports